import { acceptHMRUpdate, defineStore } from 'pinia'

export const useCarrierBlockedStore = defineStore('carrierBlocked', {
  state: () => ({
    // The blocked page's guard verifies blocking with an API call that itself 403s, and the
    // interceptor sees it while the origin page is still current — reacting to the guard's own
    // 403 would cancel and restart the navigation in an infinite request loop.
    redirectInFlight: false,
  }),
  actions: {
    startRedirect() {
      this.redirectInFlight = true
    },
    finishRedirect() {
      this.redirectInFlight = false
    },
  },
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useCarrierBlockedStore, import.meta.hot))
